// AppShell — корневой layout: TopAppBar + (NavRail на desktop / SideDrawer на mobile) + main content.
// Используется в D (routing) как обёртка для protected routes.
import type { ReactNode } from 'react';
import { Box } from '@mui/material';
import { TopAppBar } from './TopAppBar';
import { NavRail } from './NavRail';
import { SideDrawer } from './SideDrawer';
import { useResponsiveLayout } from './ResponsiveLayout';
import { useState } from 'react';

interface AppShellProps {
  children: ReactNode;
}

/** Корневой layout приложения — TopAppBar + Navigation + main content area. */
export function AppShell({ children }: AppShellProps): JSX.Element {
  const { isMobile } = useResponsiveLayout();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        <TopAppBar onMenuClick={() => setDrawerOpen(true)} />
        <Box sx={{ display: 'flex', flexGrow: 1 }}>
          {!isMobile ? <NavRail /> : null}
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: { xs: 2, md: 3 },
              maxWidth: '100%',
              overflow: 'auto',
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
      {isMobile ? <SideDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} /> : null}
    </Box>
  );
}
